export default __webpack_public_path__ + "static/project-slide-6-415-700-2c01987bcd9690a4f3973444c9657960.jpg";